import { PropsWithChildren } from 'react';
import SecondaryPanel from 'lib/SecondaryPanel';
import { useDispatch, useSelector } from 'react-redux';
import { useSecondaryPanelNextNavigation } from 'customHooks/useSecondaryPanelNextNavigation';
import {
  getCurrentProductSecondaryPanel,
  getIsCurrentProductSecondaryPanelFilled,
  getIsCurrentProductSecondaryPanelRequired,
  getNextRequiredProductSecondaryPanel,
} from 'store/productManagement/selectors';
import { changeSecondaryPanel } from 'store/productManagement/reducer';
import { SelectionPermission } from 'store/productManagement/reducer.types';
import { ProductSecondaryPanelProps } from './ProductSecondaryPanel.types';
import { shouldSkipNextRequiredPanelException } from '../ProductTargets/utils';

export const ProductSecondaryPanel = ({
  children,
  size,
  title,
  isDisabled,
  showBackButton,
  customStyles,
  confirmButtonLabel,
  confirmButtonColor,
  cancelButtonLabel,
  onSubmit,
  onCancel,
  onBack,
  isSubsection,
  isMainLevel,
  isChange,
  isOutsideClickDisabled,
  pendoId,
  selectedPermission = SelectionPermission.ALL_OPTIONS,
}: PropsWithChildren<ProductSecondaryPanelProps>): React.ReactElement => {
  const dispatch = useDispatch();

  const currentPanel = useSelector(getCurrentProductSecondaryPanel);
  const isCurrentPanelRequired = useSelector(getIsCurrentProductSecondaryPanelRequired);
  const isCurrentPanelFilled = useSelector(getIsCurrentProductSecondaryPanelFilled);
  const nextRequiredPanel = useSelector(getNextRequiredProductSecondaryPanel);

  const { handleSubmit, submitButtonLabel } = useSecondaryPanelNextNavigation({
    currentPanel,
    isCurrentPanelRequired,
    isCurrentPanelFilled,
    nextRequiredPanel,
    isChange,
    confirmButtonLabel,
    onSubmit,
    onNavigateNext: (nextPanel) => dispatch(changeSecondaryPanel(nextPanel)),
    shouldSkipNextPanel: (current, next) => shouldSkipNextRequiredPanelException(selectedPermission, current, next),
  });

  return (
    <SecondaryPanel
      size={size}
      title={title}
      isDisabled={isDisabled}
      showBackButton={showBackButton}
      customStyles={customStyles}
      confirmButtonLabel={submitButtonLabel}
      confirmButtonColor={confirmButtonColor}
      cancelButtonLabel={cancelButtonLabel}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      onBack={onBack}
      isSubsection={isSubsection}
      isMainLevel={isMainLevel}
      isChange={isChange}
      isOutsideClickDisabled={isOutsideClickDisabled}
      pendoId={pendoId}
    >
      {children}
    </SecondaryPanel>
  );
};

export default ProductSecondaryPanel;
